import lockScroll from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class popupHandler {
	constructor() {
		this.popupOpen = $('.popup-trigger__open');
		this.popupClose = $('.popup-trigger__close');
		this.popupPrev = $('.popup-trigger__prev');
		this.popupNext = $('.popup-trigger__next');
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.popupOpen.on('click', this.openPopup);
		this.popupClose.on('click', this.closePopup);
		this.popupPrev.on('click', this.prevPopup);
		this.popupNext.on('click', this.nextPopup);
	}
	openPopup(e) {
		e.preventDefault();
		const popupTriggerWrapper = $(this).closest('.popup-trigger__wrapper');

		popupTriggerWrapper.next('.popup-container__wrapper').addClass('active');
		lockScroll.lock();
	}
	closePopup(e) {
		e.preventDefault();
		const popupWrapper = $(this).closest('.popup-container__wrapper');
		popupWrapper.removeClass('active');
		lockScroll.unlock();
	}
	nextPopup(e) {
		e.preventDefault();
		const popupWrapper = $(this).closest('.popup-container__wrapper');
		popupWrapper.removeClass('active');
		let popupWrapperNext = popupWrapper.nextAll('.popup-container__wrapper:first');
		if( popupWrapperNext.length > 0 ) {
			popupWrapperNext.addClass('active');
		} else {
			lockScroll.unlock();
		}
	}
	prevPopup(e) {
		e.preventDefault();
		const popupWrapper = $(this).closest('.popup-container__wrapper');
		popupWrapper.removeClass('active');
		let popupWrapperNext = popupWrapper.prevAll('.popup-container__wrapper:first');
		if( popupWrapperNext.length > 0 ) {
			popupWrapperNext.addClass('active');
		} else {
			lockScroll.unlock();
		}
	}
}
export default new popupHandler();
